/**
 * Created by rathompson on 12/3/21
 * File: RemoveIdentityConfirmationModal
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useCallback } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Body
} from '@panwds/react-ui'
import {
  BUTTON_CANCEL,
  BUTTON_REMOVE,
  LABEL_REMOVE_IDENTITY,
  LABEL_REMOVE_CONFIRM
} from '../../../../constants/LabelConstants'
import {
  DATA_TEST_REMOVE_IDENTITY_BUTTON
} from '../../../../../common/constants/TestingDataIds'

import '../../../../styles/Modals.scss'

/**
 *   A confirmation dialog displayed after the user clicks remove button
 */
const RemoveIdentityConfirmationModal = ({ closeModal, isOpen, onRemove: _onRemove }) => {
  /**
   *     ========= Callback ===========
   */
  const onRemove = useCallback(() => {
    closeModal()
    _onRemove()
  }, [_onRemove, closeModal])

  return (
    <Modal
      style={{ zIndex: 1056, top: '35%' }}
      size='sm'
      onClose={closeModal}
      isOpen={isOpen}
    >
      <div className="header-wrapper">
        <ModalHeader title={LABEL_REMOVE_IDENTITY} />
      </div>
      <ModalBody>
        <div className='tw-flex tw-flex-col tw-gap-2'>
          <Body addClassName='tw-text-gray-600'>{LABEL_REMOVE_CONFIRM}</Body>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={closeModal}
          appearance='secondary'>
          {BUTTON_CANCEL}
        </Button>
        <Button
          data-testid={DATA_TEST_REMOVE_IDENTITY_BUTTON}
          onClick={onRemove}
          focusOnMount
          appearance='secondary-destructive'>
          {BUTTON_REMOVE}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

RemoveIdentityConfirmationModal.propTypes = {}
export default RemoveIdentityConfirmationModal
